export default __webpack_public_path__ + "static/media/log-out-outline.9acbf5a7.svg";